/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PrivacyAuthorizationListQueryVariables = {
    count: number;
    cursor?: string | null;
    appuserId: string;
};
export type PrivacyAuthorizationListQueryResponse = {
    readonly appuser: {
        readonly " $fragmentRefs": FragmentRefs<"PrivacyAuthorizationList_appuser">;
    } | null;
};
export type PrivacyAuthorizationListQuery = {
    readonly response: PrivacyAuthorizationListQueryResponse;
    readonly variables: PrivacyAuthorizationListQueryVariables;
};



/*
query PrivacyAuthorizationListQuery(
  $count: Int!
  $cursor: String
  $appuserId: ID!
) {
  appuser: node(id: $appuserId) {
    __typename
    ...PrivacyAuthorizationList_appuser_1G22uz
    id
  }
}

fragment PrivacyAuthorizationList_appuser_1G22uz on AppUserNode {
  privacyAuthorizations(first: $count, after: $cursor) {
    edges {
      node {
        id
        historyStart
        historyEnd
        notValidAfter
        reason
        grantedBy
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  id
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appuserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appuserId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivacyAuthorizationListQuery",
    "selections": [
      {
        "alias": "appuser",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PrivacyAuthorizationList_appuser"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PrivacyAuthorizationListQuery",
    "selections": [
      {
        "alias": "appuser",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "AUAppDataPrivacyAuthorizationConnection",
                "kind": "LinkedField",
                "name": "privacyAuthorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppDataPrivacyAuthorizationNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppDataPrivacyAuthorizationNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "historyStart",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "historyEnd",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notValidAfter",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "grantedBy",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "PrivacyAuthorizationList_privacyAuthorizations",
                "kind": "LinkedHandle",
                "name": "privacyAuthorizations"
              }
            ],
            "type": "AppUserNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6d5d6512dde1093d03ab08801926837d",
    "id": null,
    "metadata": {},
    "name": "PrivacyAuthorizationListQuery",
    "operationKind": "query",
    "text": "query PrivacyAuthorizationListQuery(\n  $count: Int!\n  $cursor: String\n  $appuserId: ID!\n) {\n  appuser: node(id: $appuserId) {\n    __typename\n    ...PrivacyAuthorizationList_appuser_1G22uz\n    id\n  }\n}\n\nfragment PrivacyAuthorizationList_appuser_1G22uz on AppUserNode {\n  privacyAuthorizations(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        historyStart\n        historyEnd\n        notValidAfter\n        reason\n        grantedBy\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();
(node as any).hash = 'a1758940a254a5cb8eea49687aa90246';
export default node;
